import { useState } from "react";
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import useAuth from "../../../../../components/hooks/useAuth";
import baseURL from "../../../../../configs/api";
import colorConfigs from "../../../../../configs/colorConfigs";
import PleaseWaitPopup from "../../../../PleaseWaitPopup";
import { useTheme } from "../../../../../components/hooks/useTheme";
import ReactQuill from "react-quill";
import Cookies from "js-cookie";
import useTenant from "../../../../../components/hooks/useTenant";

export const AddFaq = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const token = Cookies.get("token-jj-rental-ui");
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { themeStyles, theme } = useTheme();
    const navigate = useNavigate();
    const [question, setQuestion] = useState<string>("");
    const [answer, setAnswer] = useState<string>("");
    const [isActive, setIsActive] = useState<string>("No");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const modules = {
        toolbar: [
            [{ font: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
            ["link", "image", "video"],
            ["clean"],
        ],
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        await axios
            .post(
                `${baseURL}faq?userId=${auth?.id}`,
                JSON.stringify({
                    question,
                    answer,
                    isActive: isActive === "Yes"                 
                }),
                {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    withCredentials: true,
                }
            )
            .then(() => {
                setPleaseWaitPopup(false);
                navigate(-1);
                handleTenantError(null);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
            });
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>

                            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add FAQ</h2>
                                </div>
                            </div>

                            <div className="mt-2 p-2">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="w-full px-2">
                                        <div>
                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Question</label>
                                            <input
                                                type="text"
                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                value={question}
                                                onChange={(e) => setQuestion(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div
                                            className="quill-wrapper my-2"
                                            style={{
                                                ...(theme === 'dark' && {
                                                    '--quill-text-color': '#ffffff',
                                                    '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                                                }),
                                            } as React.CSSProperties}
                                        >

                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Answer</label>
                                            <ReactQuill
                                                className="custom-quill"

                                                theme="snow"
                                                modules={modules}
                                                value={answer}
                                                onChange={setAnswer}
                                            />
                                        </div>

                                        <div className="mt-4 flex gap-14">
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                                                <RadioGroup
                                                    row
                                                    value={isActive}
                                                    onChange={(e) => setIsActive(e.target.value)}
                                                >
                                                    <FormControlLabel
                                                        value="Yes" control=
                                                        {<Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "#167AC3",
                                                                },
                                                            }}
                                                        />} label="Yes"
                                                        sx={{
                                                            color: themeStyles.form.labelTextColor
                                                        }}
                                                    />
                                                    <FormControlLabel value="No" control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "#167AC3",
                                                                },
                                                            }}
                                                        />} label="No"
                                                        sx={{
                                                            color: themeStyles.form.labelTextColor
                                                        }}
                                                    />
                                                </RadioGroup>
                                            </div>                                         
                                        </div>
                                    </div>

                                    <div className="flex gap-4 mt-6">
                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.main.bg
                                            }}
                                            type="submit">
                                            Save
                                        </Button>

                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.cancel.bg,
                                                border: colorConfigs.btn.cancel.border,
                                                color: colorConfigs.btn.cancel.color
                                            }}
                                            onClick={() => navigate(-1)}>
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>
                {`
    .custom-quill .ql-container {
      height: 200px;
    }

    .custom-quill .ql-editor {
      padding: 12px;
      height: 100%;
      overflow-y: auto;
    }

    .custom-quill .ql-toolbar {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }

    .custom-quill .ql-container {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  `}
            </style>
            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    )
}
